/* Cero · Mi pedido (Pedro 2026-10-15: «para la gente que quiere saber de su pedido… cuando un cliente esté enojado… dudas de
   suscripción» → «a ver, a debug»). Página para quien ya compró: número de pedido + correo/teléfono → tarjeta con el estado real y
   chat con Cero. Solo lee: pausar/cancelar lo hace ella en su portal (botón), y lo delicado lo escala Cero al equipo de atención.
   Si el servidor dice que Cero está apagado (centinela o interruptor), la página muestra el correo de atención y no carga el chat. */
(function () {
  'use strict';
  var raiz = document.getElementById('agc-mp');
  if (!raiz || raiz.dataset.listo) return;
  raiz.dataset.listo = '1';
  var API = raiz.dataset.api || 'https://go.aguacero.mx/api/chat';
  var KEY = 'agc_mp_v1', CPS = 46, MIN_TYPING = 1200;
  var REDUCE = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CHIPS0 = ['¿Cuándo me llega?', '¿Cuándo llega mi próximo filtro?', 'Tengo un problema con mi pedido'];   /* sin «cancelar» de entrada (miedo a churn) */

  function el(t, c, x) { var e = document.createElement(t); if (c) e.className = c; if (x != null) e.textContent = x; return e; }
  function sget() { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function sset(v) { try { sessionStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function sid() { return 'p' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }
  var st = sget() || { id: sid(), msgs: [] };
  function medir(ev, md) {
    try {
      fetch(API.replace(/\/api\/chat$/, '') + '/api/popup/event', { method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
        body: JSON.stringify({ session_id: st.id, event: ev, metadata: md || {}, page_path: location.pathname, referrer: document.referrer || null }) });
    } catch (e) {}
  }
  addEventListener('error', function (e) { if (/agc-pedido\.js/.test(e.filename || '')) medir('enc_chat_err', { m: String(e.message).slice(0, 140), f: 'agc-pedido.js' }); });
  function cero(host, size, est) {
    if (!window.CeroB) return null;
    try { var c = CeroB.mount(host, { size: size }); if (est) c.estado(est); return c; } catch (e) { return null; }
  }

  raiz.textContent = '';
  var hd = el('div', 'agc-mp-hd'), hc = el('span', 'agc-mp-hd-c'), ht = el('div');
  ht.appendChild(el('b', null, 'Cero')); ht.appendChild(el('span', null, 'Asistencia Aguacero · en línea'));
  hd.appendChild(hc); hd.appendChild(ht); raiz.appendChild(hd);
  var cara = cero(hc, 34, 'saluda');
  var cuerpo = el('div', 'agc-mp-cuerpo'); raiz.appendChild(cuerpo);

  /* ── Apagado: correo de atención, sin chat ── */
  function apagado() {
    cuerpo.textContent = '';
    var b = el('div', 'agc-mp-apagado');
    b.appendChild(el('p', null, 'Cero está descansando un momento. Para cualquier cosa de tu pedido, escríbenos y te contestamos hoy.'));
    var a = el('a', 'agc-mp-btn', 'Escribir a hola@aguacero.mx'); a.href = 'mailto:hola@aguacero.mx'; b.appendChild(a);
    cuerpo.appendChild(b);
  }

  /* ── Paso 1: buscar el pedido ── */
  function formulario(error) {
    cuerpo.textContent = '';
    var intro = el('div', 'agc-chat-msg agc-chat-msg--bot', 'Hola, soy Cero. Escribe el correo o el teléfono con el que compraste y te digo cómo va tu pedido.');
    cuerpo.appendChild(intro);
    var f = el('form', 'agc-mp-form'); f.noValidate = true;
    var q = new URLSearchParams(location.search);
    /* Un solo campo (Pedro 2026-10-15: «¿no se puede simplemente con 1 de las opciones?… hacérselos más fácil»). El número de pedido
       es opcional: llega solo en el enlace de los correos (?pedido=) y no se le pide a nadie. */
    var pedidoUrl = (q.get('pedido') || '').replace(/\D/g, '');
    var d = el('input', 'agc-mp-in'); d.placeholder = 'Correo o teléfono con el que compraste'; d.autocomplete = 'email'; d.value = q.get('correo') || '';
    var b = el('button', 'agc-mp-btn', 'Ver mi pedido'); b.type = 'submit';
    var e = el('p', 'agc-mp-err'); e.setAttribute('role', 'alert'); if (error) e.textContent = error;
    f.appendChild(d); f.appendChild(b); f.appendChild(e);
    cuerpo.appendChild(f);
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (d.value.trim().length < 5) { e.textContent = 'Escribe el correo o el teléfono con el que compraste.'; return; }
      b.disabled = true; b.textContent = 'Buscando…'; e.textContent = ''; if (cara) cara.estado('piensa');
      fetch(API + '/pedido/buscar', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ pedido: pedidoUrl, dato: d.value.trim() }) })
        .then(function (r) { return r.json().then(function (j) { return { s: r.status, j: j }; }); })
        .then(function (x) {
          if (cara) cara.estado('reposo');
          if (x.s === 200) { dato = d.value.trim(); st.pase = x.j.pase; st.pedido = x.j.pedido; st.otros = x.j.otros || []; st.hasta = Date.now() + 110 * 60000; st.msgs = []; sset(st); medir('enc_mp_ok', { otros: st.otros.length }); return conversacion(); }
          medir('enc_mp_busca', { ok: false, s: x.s });
          b.disabled = false; b.textContent = 'Ver mi pedido';
          e.textContent = x.s === 429 ? 'Demasiados intentos. Espera unos minutos y vuelve a intentar.' : x.s === 503 ? '' : 'No encontramos un pedido con ese dato. Prueba con el otro (correo o teléfono) con el que compraste.';
          if (x.s === 503) apagado();
        }, function () { b.disabled = false; b.textContent = 'Ver mi pedido'; e.textContent = 'Se me fue la señal. Intenta otra vez.'; if (cara) cara.estado('reposo'); });
    });
    if (!d.value) d.focus({ preventScroll: true });
  }

  /* ── Paso 2: tarjeta del pedido + chat ── */
  var log, chips, inp, send, busy = false, dato = '';   /* el correo/teléfono vive solo en memoria: para cambiar de pedido sin volver a pedirlo */
  function tarjeta(t) {
    var c = el('div', 'agc-mp-card');
    var top = el('div', 'agc-mp-card-t'); var tx = el('div');
    tx.appendChild(el('small', null, 'Pedido ' + t.nombre)); tx.appendChild(el('b', null, (t.articulos || []).join(' · ') || 'Tu pedido'));
    top.appendChild(tx); c.appendChild(top);
    if (t.cancelado) { c.appendChild(el('p', 'agc-mp-card-x', 'Este pedido está cancelado.')); return c; }
    var pasos = [['pagado', 'Pagado'], ['preparado', 'Preparado'], ['en_camino', 'En camino'], ['entregado', 'Entregado']];
    var ult = -1; pasos.forEach(function (k, i) { if (t.pasos && t.pasos[k[0]]) ult = i; });
    var tl = el('div', 'agc-mp-tl'), tx2 = el('div', 'agc-mp-tlx');
    pasos.forEach(function (k, i) { tl.appendChild(el('i', i < ult ? 'on' : i === ult ? 'ya' : '')); tx2.appendChild(el('span', null, k[1])); });
    c.appendChild(tl); c.appendChild(tx2);
    if (t.guia && t.guia.url) {
      var a = el('a', 'agc-mp-btn agc-mp-btn--mini', 'Ver guía' + (t.guia.company ? ' · ' + t.guia.company.replace(/Sdx$/, '') : ''));
      a.href = t.guia.url; a.target = '_blank'; a.rel = 'noopener'; a.addEventListener('click', function () { medir('enc_mp_guia', {}); });
      c.appendChild(a);
    }
    return c;
  }
  function burbuja(q, txt) { var b = el('div', 'agc-chat-msg agc-chat-msg--' + q, txt); log.appendChild(b); abajo(); return b; }
  function abajo() {   /* la página entera es la conversación: se baja a lo último, con el campo de escribir fijo abajo */
    var u = cuerpo.lastElementChild; if (u && u.scrollIntoView) u.scrollIntoView({ block: 'end', behavior: REDUCE ? 'auto' : 'smooth' });
  }
  function ponerChips(l) {
    chips.textContent = '';
    (l || []).forEach(function (c, i) { var b = el('button', 'agc-chat-chip', c); b.type = 'button'; b.style.animationDelay = (i * 90) + 'ms';
      b.addEventListener('click', function () { preguntar(c, 'chip'); }); chips.appendChild(b); });
  }
  function boton(txt, href, ev) {
    var a = el('a', 'agc-mp-btn agc-mp-btn--mini', txt); a.href = href; a.target = '_blank'; a.rel = 'noopener';
    a.addEventListener('click', function () { medir(ev, {}); }); var w = el('div', 'agc-mp-acc'); w.appendChild(a); log.appendChild(w); abajo();
  }
  function pensando() {
    var b = el('div', 'agc-chat-think'), h = el('span', 'agc-chat-think-c'), gs = el('span', 'agc-chat-think-g');
    gs.appendChild(el('i')); gs.appendChild(el('i')); gs.appendChild(el('i')); b.appendChild(h); b.appendChild(gs);
    b._c = cero(h, 52, 'piensa'); log.appendChild(b); abajo();
    return function () { if (b._c) b._c.destruir(); b.remove(); };
  }
  function conversacion() {
    cuerpo.textContent = '';
    cuerpo.appendChild(tarjeta(st.pedido));
    if (dato && st.otros && st.otros.length) {
      var ot = el('div', 'agc-mp-otros'); ot.appendChild(el('span', null, 'Tus otros pedidos'));
      st.otros.forEach(function (n) {
        var bo = el('button', 'agc-chat-chip', n); bo.type = 'button';
        bo.addEventListener('click', function () {
          bo.disabled = true;
          fetch(API + '/pedido/buscar', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ pedido: n, dato: dato }) })
            .then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
              if (!j) { bo.disabled = false; return; }
              st.pase = j.pase; st.pedido = j.pedido; st.otros = st.otros.filter(function (x) { return x !== n; }).concat([st.otros && st.pedido ? '' : '']).filter(Boolean);
              st.msgs = []; sset(st); medir('enc_mp_otro', {}); conversacion();
            }, function () { bo.disabled = false; });
        });
        ot.appendChild(bo);
      });
      cuerpo.appendChild(ot);
    }
    log = el('div', 'agc-mp-log'); cuerpo.appendChild(log);
    chips = el('div', 'agc-chat-chips agc-mp-chips'); cuerpo.appendChild(chips);
    var f = el('form', 'agc-chat-ft agc-mp-ft');
    inp = el('input', 'agc-chat-in'); inp.placeholder = 'Escribe tu pregunta'; inp.maxLength = 500; inp.enterKeyHint = 'send';
    send = el('button', 'agc-chat-send'); send.type = 'submit'; send.setAttribute('aria-label', 'Enviar');
    send.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h13M13 6l6 6-6 6"/></svg>';
    f.appendChild(inp); f.appendChild(send); cuerpo.appendChild(f);
    f.addEventListener('submit', function (e) { e.preventDefault(); var t = inp.value.trim(); if (t) { inp.value = ''; preguntar(t, 'texto'); } });
    var otro = el('button', 'agc-mp-otro', 'Ver otro pedido'); otro.type = 'button';
    otro.addEventListener('click', function () { st = { id: sid(), msgs: [] }; sset(st); formulario(); }); cuerpo.appendChild(otro);
    burbuja('bot', 'Listo, ya tengo tu pedido ' + st.pedido.nombre + '. ¿Qué quieres saber?');
    st.msgs.forEach(function (m) { burbuja(m.role === 'user' ? 'me' : 'bot', m.content); });
    ponerChips(st.msgs.length ? (st.chips || []) : CHIPS0);
  }

  function preguntar(texto, via) {
    if (busy) return; busy = true; send.disabled = true; ponerChips([]);
    burbuja('me', texto); if (cara) cara.estado('piensa');
    st.msgs.push({ role: 'user', content: texto.slice(0, 500) }); sset(st);
    medir('enc_mp_msg', { via: via, n: st.msgs.length });
    var quita = null, t0 = Date.now(); setTimeout(function () { if (busy && !quita) quita = pensando(); }, 200);
    fetch(API + '/pedido', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: st.id, pase: st.pase, messages: st.msgs, contexto: {}, capacidades: ['direccion'] }) })
      .then(function (r) {
        if (r.status === 401) { st = { id: st.id, msgs: [] }; sset(st); throw { vencido: true }; }
        if (r.status === 503) throw { apagado: true };
        if (!r.ok) throw new Error('http ' + r.status);
        return r.text();
      })
      .then(function (raw) {
        var txt = '', meta = {};
        raw.split('\n\n').forEach(function (blk) {
          var ev = (blk.match(/^event: (.*)$/m) || [])[1], dl = (blk.match(/^data: (.*)$/m) || [])[1];
          if (!ev || dl == null) return; var d; try { d = JSON.parse(dl); } catch (e) { return; }
          if (ev === 'delta') txt += d.t; else if (ev === 'meta') meta = d;
        });
        var espera = Math.max(0, MIN_TYPING - (Date.now() - t0));
        setTimeout(function () { mostrar(txt || 'Se me fue la señal un segundo. ¿Me lo repites?', meta); }, REDUCE ? 0 : espera);
      })
      .catch(function (e) {
        if (quita) quita(); quita = function () {};
        busy = false; send.disabled = false; if (cara) cara.estado('reposo');
        if (e && e.apagado) return apagado();
        if (e && e.vencido) return formulario('Por seguridad, vuelve a escribir tu número de pedido y tu correo.');
        burbuja('bot', 'Se me fue la señal un segundo. ¿Me lo repites?');
      });
    function mostrar(txt, meta) {
      if (quita) quita(); quita = function () {};
      var partes = txt.split(/\n\s*\n/).map(function (p) { return p.trim(); }).filter(Boolean), i = 0;
      if (cara) cara.estado('habla');
      (function siguiente() {
        if (i >= partes.length) return cierre(txt, meta);
        var b = burbuja('bot', ''), p = partes[i++], n = 0;
        if (REDUCE) { b.textContent = p; return siguiente(); }
        var tk = setInterval(function () {
          n = Math.min(p.length, n + Math.max(1, Math.round(CPS / 20)));
          var corte = n < p.length ? p.lastIndexOf(' ', n) : n; b.textContent = p.slice(0, corte > 0 ? corte : n); abajo();
          if (n >= p.length) { clearInterval(tk); setTimeout(siguiente, 450); }
        }, 50);
      })();
    }
    function cierre(txt, meta) {
      st.msgs.push({ role: 'assistant', content: txt }); st.chips = meta.chips || []; sset(st);
      if (meta.guia && meta.guia.url) boton('Ver mi guía', meta.guia.url, 'enc_mp_guia');
      if (meta.portal) boton('Abrir mi Aguacero Plus+', meta.portal, 'enc_mp_portal');
      if (meta.escalado) { var n = el('div', 'agc-mp-nota', 'Caso enviado a nuestro equipo de atención'); log.appendChild(n); medir('enc_mp_escalado', {}); }
      if (meta.direccion) { st.chips = []; formDireccion(); }
      ponerChips(st.chips); busy = false; send.disabled = false; abajo();
      if (cara) cara.estado(meta.escalado ? 'reposo' : 'feliz'); setTimeout(function () { if (cara) cara.estado('reposo'); }, 1600);
    }
  }

  /* ── Cambio de dirección (Pedro 2026-10-15: «que Cero pueda hacer el cambio de dirección automáticamente… con inteligencia, si ya
     salió no se puede» · «cobra $149»). Formulario → «¿Así está bien?» → el servidor revisa si ya salió y contesta. ── */
  var ESTADOS = [['AGS','Aguascalientes'],['BC','Baja California'],['BCS','Baja California Sur'],['CAMP','Campeche'],['CHIS','Chiapas'],
    ['CHIH','Chihuahua'],['DF','Ciudad de México'],['COAH','Coahuila'],['COL','Colima'],['DGO','Durango'],['MEX','Estado de México'],
    ['GTO','Guanajuato'],['GRO','Guerrero'],['HGO','Hidalgo'],['JAL','Jalisco'],['MICH','Michoacán'],['MOR','Morelos'],['NAY','Nayarit'],
    ['NL','Nuevo León'],['OAX','Oaxaca'],['PUE','Puebla'],['QRO','Querétaro'],['Q ROO','Quintana Roo'],['SLP','San Luis Potosí'],
    ['SIN','Sinaloa'],['SON','Sonora'],['TAB','Tabasco'],['TAMPS','Tamaulipas'],['TLAX','Tlaxcala'],['VER','Veracruz'],['YUC','Yucatán'],['ZAC','Zacatecas']];
  function formDireccion(prev) {
    var v = prev || {}, f = el('form', 'agc-mp-dir'); f.noValidate = true;
    function campo(k, ph, extra) {
      var i = el('input', 'agc-mp-in'); i.name = k; i.placeholder = ph; i.value = v[k] || ''; i.maxLength = k === 'referencias' ? 200 : 120;
      if (extra) extra(i); f.appendChild(i); return i;
    }
    f.appendChild(el('b', 'agc-mp-dir-t', 'Tu dirección nueva'));
    campo('calle', 'Calle y número (exterior e interior)', function (i) { i.autocomplete = 'address-line1'; });
    var fila = el('div', 'agc-mp-dir-2'); f.appendChild(fila);
    var cp = campo('cp', 'CP', function (i) { i.inputMode = 'numeric'; i.maxLength = 5; i.autocomplete = 'postal-code'; }); fila.appendChild(cp);
    var ci = campo('ciudad', 'Ciudad o municipio', function (i) { i.autocomplete = 'address-level2'; }); fila.appendChild(ci);
    var lista = listaColonias(cp, campo('colonia', 'Colonia', function (i) { i.autocomplete = 'address-line2'; }));
    var se = el('select', 'agc-mp-in agc-mp-sel'); se.name = 'estado'; se.appendChild(el('option', null, 'Estado')).value = '';
    ESTADOS.forEach(function (e) { var o = el('option', null, e[1]); o.value = e[0]; if (v.estado === e[0]) o.selected = true; se.appendChild(o); });
    f.appendChild(se);
    campo('referencias', 'Referencias (opcional)');
    var b = el('button', 'agc-mp-btn', 'Revisar dirección'); b.type = 'submit'; f.appendChild(b);
    var e = el('p', 'agc-mp-err'); e.setAttribute('role', 'alert'); f.appendChild(e);
    log.appendChild(f); abajo(); medir('enc_mp_dir_form', {});
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var d = { calle: f.calle.value.trim(), colonia: f.colonia.value.trim(), cp: f.cp.value.replace(/\D/g, ''), ciudad: f.ciudad.value.trim(),
                estado: se.value, referencias: f.referencias.value.trim() };
      var falta = !/\d|s\/?n/i.test(d.calle) ? 'Escribe la calle con su número.' : d.cp.length !== 5 ? 'El código postal lleva 5 números.' :
        lista.falta() || (d.colonia.length < 2 ? 'Escribe la colonia.' : d.ciudad.length < 2 ? 'Escribe la ciudad o municipio.' : !d.estado ? 'Elige el estado.' : '');
      if (falta) { e.textContent = falta; return; }
      f.remove(); confirmarDireccion(d);
    });
    if (!prev) f.calle.focus({ preventScroll: true });
  }
  /* Colonia de lista (Pedro 2026-11-03: «ok dale»): con el CP completo, las colonias de Correos para elegir; la bodega solo guía con
     ese nombre exacto (82 de 209 folios del 2-nov traían una colonia escrita a mano). La elegida se escribe en el campo de siempre;
     «Mi colonia no aparece» o un CP sin catálogo dejan escribirla. */
  function listaColonias(cpIn, colIn) {
    var se = el('select', 'agc-mp-in agc-mp-sel'), escrita = colIn.value, pedido = '', OTRA = '__otra';
    se.name = 'colonia_lista'; se.style.display = 'none'; colIn.parentNode.insertBefore(se, colIn.nextSibling);
    function norm(s) { return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
    function texto() { se.style.display = 'none'; colIn.style.display = ''; }
    function cargar() {
      var c = cpIn.value.replace(/\D/g, '');
      if (c.length !== 5) { if (pedido) { pedido = ''; colIn.value = escrita; texto(); } return; }
      if (c === pedido) return;
      pedido = c;
      fetch(API + '/pedido/colonias?cp=' + c).then(function (r) { return r.ok ? r.json() : { colonias: [] }; }).then(function (j) {
        if (pedido !== c) return;
        var cols = j.colonias || [];
        if (!cols.length) { colIn.value = escrita; return texto(); }
        se.textContent = ''; se.appendChild(el('option', null, 'Elige tu colonia')).value = '';
        cols.forEach(function (n) { se.appendChild(el('option', null, n)).value = n; });
        se.appendChild(el('option', null, 'Mi colonia no aparece')).value = OTRA;
        var ya = cols.filter(function (n) { return norm(n) === norm(escrita); })[0] || (cols.length === 1 ? cols[0] : '');
        se.value = ya; colIn.value = ya; colIn.style.display = 'none'; se.style.display = '';
        medir('enc_mp_col_lista', { n: cols.length, ya: !!ya });
      }, function () { if (pedido === c) { colIn.value = escrita; texto(); } });
    }
    se.addEventListener('change', function () {
      var err = colIn.form && colIn.form.querySelector('.agc-mp-err'); if (err && se.value) err.textContent = '';
      if (se.value !== OTRA) { colIn.value = se.value; return; }
      colIn.value = ''; colIn.placeholder = 'Escribe tu colonia'; colIn.style.display = ''; colIn.focus(); medir('enc_mp_col_otra', {});
    });
    colIn.addEventListener('input', function () { if (se.style.display === 'none' || se.value === OTRA) escrita = colIn.value; });
    cpIn.addEventListener('input', cargar);
    cargar();
    return { falta: function () { return se.style.display !== 'none' && !se.value ? 'Elige tu colonia.' : ''; } };
  }
  function lineaDir(d) {
    var nom = ''; ESTADOS.forEach(function (e) { if (e[0] === d.estado) nom = e[1]; });
    return [d.calle, d.colonia, 'CP ' + d.cp, d.ciudad, nom].join(', ') + (d.referencias ? ' (' + d.referencias + ')' : '');
  }
  function confirmarDireccion(d) {
    burbuja('bot', '¿Así está bien?\n' + lineaDir(d)).classList.add('agc-mp-dir-conf');
    var w = el('div', 'agc-mp-acc agc-mp-dir-acc'), si = el('button', 'agc-mp-btn agc-mp-btn--mini', 'Sí, es correcta'), no = el('button', 'agc-chat-chip', 'Corregir');
    si.type = no.type = 'button'; w.appendChild(si); w.appendChild(no); log.appendChild(w); abajo();
    no.addEventListener('click', function () { w.remove(); formDireccion(d); });
    si.addEventListener('click', function () {
      w.remove(); if (busy) return; busy = true; send.disabled = true; if (cara) cara.estado('piensa');
      var quita = pensando(), t0 = Date.now();
      fetch(API + '/pedido/direccion', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pase: st.pase, session_id: st.id, calle: d.calle, colonia: d.colonia, cp: d.cp, ciudad: d.ciudad, estado: d.estado, referencias: d.referencias }) })
        .then(function (r) { if (r.status === 401) throw { vencido: true }; if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(function (j) {
          setTimeout(function () {
            quita(); busy = false; send.disabled = false;
            (j.texto || '').split(/\n\s*\n/).forEach(function (p) { if (p.trim()) burbuja('bot', p.trim()); });
            if (j.seco) log.appendChild(el('div', 'agc-mp-nota', 'Modo prueba: no se cambió nada'));
            st.msgs.push({ role: 'assistant', content: j.texto || '' }); sset(st);
            medir('enc_mp_dir_ok', { resultado: j.resultado, carril: j.carril });
            if (cara) { cara.estado(j.resultado === 'aplicado' ? 'feliz' : 'reposo'); setTimeout(function () { cara.estado('reposo'); }, 1600); }
            abajo();
          }, REDUCE ? 0 : Math.max(0, MIN_TYPING - (Date.now() - t0)));
        })
        .catch(function (x) {
          quita(); busy = false; send.disabled = false; if (cara) cara.estado('reposo');
          if (x && x.vencido) return formulario('Por seguridad, vuelve a escribir tu correo o teléfono.');
          burbuja('bot', 'No pude guardar tu dirección. ¿Lo intentamos otra vez?'); medir('enc_mp_dir_err', {}); formDireccion(d);
        });
    });
  }

  /* «Revisa tu dirección» (Pedro 2026-10-19): el botón del correo o del WhatsApp trae ?dir=<pase de 72 h>. Abre la conversación con lo
     que le falta a la dirección y el formulario ya lleno; al confirmar sigue el mismo camino del cambio de dirección de arriba. */
  function revisarDireccion(pase) {
    try { history.replaceState(null, '', location.pathname); } catch (e) {}
    /* Viene del correo «Revisa tu dirección»: el título de la página habla de eso, no de «¿Dónde va tu pedido?» */
    var h1 = document.querySelector('.agc-pghero h1'), lede = document.querySelector('.agc-pghero .agc-pg-lede');
    if (h1) h1.innerHTML = 'Revisa tu<br><b>dirección</b>';
    if (lede) lede.textContent = 'Corrígela o confírmala aquí. En cuanto quede, tu pedido sigue su camino.';
    fetch(API + '/pedido/direccion/revisar?d=' + encodeURIComponent(pase))
      .then(function (r) { if (!r.ok) throw r.status; return r.json(); })
      .then(function (j) {
        st = { id: sid(), msgs: [], pase: j.pase, pedido: j.pedido, otros: [], hasta: Date.now() + 110 * 60000 }; sset(st);
        conversacion(); ponerChips([]);
        var b0 = log.querySelector('.agc-chat-msg--bot'); if (b0) b0.remove();   /* «¿Qué quieres saber?» sobra: viene a corregir */
        medir('enc_mp_dir_revisa', { abierto: !!j.abierto, faltas: (j.faltas || []).length });
        if (!j.abierto) { burbuja('bot', 'Tu pedido ya no está esperando envío, así que la dirección ya no se cambia desde aquí. Si necesitas algo, escríbeme.'); return; }
        var faltas = (j.faltas || []).map(function (f) { return '• ' + f; }).join('\n');
        burbuja('bot', 'Revisemos tu dirección de envío.' + (faltas ? ' Falta esto:\n' + faltas : '') + '\n\nCorrígela abajo o, si ya está bien, solo confírmala.');
        formDireccion(j.direccion);
        var tt = log.querySelector('.agc-mp-dir-t'); if (tt) tt.textContent = 'Tu dirección';
      }, function () { medir('enc_mp_dir_revisa_err', {}); formulario('El enlace ya venció. Escribe el correo o el teléfono con el que compraste.'); });
  }

  /* Rescate en ruta (Pedro 2026-10-23): la paquetería intentó entregar y no pudo. El WhatsApp trae ?ruta=<pase>: la clienta confirma
     (o corrige) su dirección y deja una referencia; eso le llega a Abdiel listo para el ticket de Skydropx antes de que el paquete regrese. */
  function rescateRuta(pase) {
    try { history.replaceState(null, '', location.pathname); } catch (e) {}
    var h1 = document.querySelector('.agc-pghero h1'), lede = document.querySelector('.agc-pghero .agc-pg-lede');
    if (h1) h1.innerHTML = 'Ayúdanos a<br><b>encontrarte</b>';
    if (lede) lede.textContent = 'La paquetería intentó entregar tu pedido. Con una referencia de tu casa, llega en el siguiente intento.';
    fetch(API + '/pedido/ruta/abrir?d=' + encodeURIComponent(pase))
      .then(function (r) { if (!r.ok) throw r.status; return r.json(); })
      .then(function (j) {
        st = { id: sid(), msgs: [], pase: j.pase, pedido: j.pedido, otros: [], hasta: Date.now() + 110 * 60000 }; sset(st);
        conversacion(); ponerChips([]);
        var b0 = log.querySelector('.agc-chat-msg--bot'); if (b0) b0.remove();
        medir('enc_mp_ruta_abre', { respondido: !!j.respondido });
        if (j.respondido) { burbuja('bot', 'Ya tenemos tu referencia y se la pasamos a la paquetería. Si necesitas algo más, escríbeme.'); return; }
        var d = j.direccion || {};
        burbuja('bot', 'La paquetería intentó entregar tu pedido y no pudo. Tenemos esta dirección:\n' + lineaDir(d) +
          '\n\nDéjanos una referencia (color de la casa, entre qué calles) para el siguiente intento.');
        formRuta(d);
      }, function () { medir('enc_mp_ruta_err', {}); formulario('El enlace ya venció. Escribe el correo o el teléfono con el que compraste.'); });
  }
  function formRuta(d) {
    var f = el('form', 'agc-mp-dir'); f.noValidate = true;
    function campo(k, ph, max, extra) { var i = el('input', 'agc-mp-in'); i.name = k; i.placeholder = ph; i.maxLength = max; if (extra) extra(i); f.appendChild(i); return i; }
    f.appendChild(el('b', 'agc-mp-dir-t', 'Para la paquetería'));
    var ref = campo('referencias', 'Referencia: color de la casa, entre qué calles…', 200);
    campo('horario', '¿A qué hora suele haber alguien? (opcional)', 80);
    campo('telefono_alt', 'Otro teléfono para el repartidor (opcional)', 20, function (i) { i.inputMode = 'tel'; });
    var mal = el('button', 'agc-chat-chip', 'Mi dirección está mal'); mal.type = 'button'; f.appendChild(mal);
    var caja = el('div', 'agc-mp-ruta-dir'); caja.hidden = true; f.appendChild(caja);
    function campoDir(k, ph) { var i = el('input', 'agc-mp-in'); i.name = k; i.placeholder = ph; i.value = d[k] || ''; i.maxLength = 120; caja.appendChild(i); return i; }
    var calle = campoDir('calle', 'Calle y número (exterior e interior)'), col = campoDir('colonia', 'Colonia'),
        cp = campoDir('cp', 'CP'), ciu = campoDir('ciudad', 'Ciudad o municipio');
    cp.inputMode = 'numeric'; cp.maxLength = 5;
    mal.addEventListener('click', function () { caja.hidden = false; mal.remove(); calle.focus(); medir('enc_mp_ruta_corrige', {}); });
    var b = el('button', 'agc-mp-btn', 'Enviar a la paquetería'); b.type = 'submit'; f.appendChild(b);
    var e = el('p', 'agc-mp-err'); e.setAttribute('role', 'alert'); f.appendChild(e);
    log.appendChild(f); abajo();
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var corrige = !caja.hidden, body = { pase: st.pase, confirma: !corrige, referencias: ref.value.trim(), horario: f.horario.value.trim(),
        telefono_alt: f.telefono_alt.value.replace(/[^\d+]/g, ''), calle: calle.value.trim(), colonia: col.value.trim(), cp: cp.value.replace(/\D/g, ''), ciudad: ciu.value.trim() };
      var falta = body.referencias.length < 5 ? 'Escribe una referencia de tu casa.' :
        corrige && !/\d|s\/?n/i.test(body.calle) ? 'Escribe la calle con su número.' : corrige && body.cp.length !== 5 ? 'El código postal lleva 5 números.' : '';
      if (falta) { e.textContent = falta; return; }
      b.disabled = true; b.textContent = 'Enviando…'; e.textContent = '';
      fetch(API + '/pedido/ruta', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (r.status === 401) throw { vencido: true }; if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(function () {
          f.remove(); medir('enc_mp_ruta_ok', { corrige: corrige });
          burbuja('bot', 'Listo, gracias. Se lo pasamos a la paquetería para el siguiente intento. Si necesitas algo más, escríbeme aquí.');
          if (cara) { cara.estado('feliz'); setTimeout(function () { cara.estado('reposo'); }, 1600); }
        })
        .catch(function (x) {
          if (x && x.vencido) return formulario('Por seguridad, vuelve a escribir tu correo o teléfono.');
          b.disabled = false; b.textContent = 'Enviar a la paquetería'; e.textContent = 'No se pudo enviar. Intenta otra vez.'; medir('enc_mp_ruta_err', {});
        });
    });
  }

  /* Arranque: ¿Cero prendido? → enlace de revisar dirección o de rescate en ruta; con pase vigente, directo a la conversación; si no, el formulario */
  var qDir = new URLSearchParams(location.search).get('dir'), qRuta = new URLSearchParams(location.search).get('ruta');
  medir('enc_mp_abre', { pedido: !!new URLSearchParams(location.search).get('pedido'), dir: !!qDir, ruta: !!qRuta });
  fetch(API + '/cfg/estado').then(function (r) { return r.ok ? r.json() : {}; }).then(function (d) {
    if (!(d && d.enabled)) return apagado();
    if (qRuta) return rescateRuta(qRuta);
    if (qDir) return revisarDireccion(qDir);
    if (st.pase && st.pedido && st.hasta > Date.now()) conversacion(); else formulario();
  }, apagado);
})();
